import { UI, HStack, Stack, VStack } from '@genial/components';
import { BoxBorder, Color, Spacing, Typography } from '@genial/design-tokens';
import { IconButton, IStackProps } from 'native-base';

export interface OrderAccordionLoadingProps {
  isMobile?: boolean;
  quantity: number;
}

export const OrderAccordionLoading = ({ quantity, isMobile }: OrderAccordionLoadingProps) => {
  const renderDoubleTextLoading = (direction: IStackProps['direction'] = 'column') => (
    <Stack direction={direction} space={Spacing['stack.quarck']}>
      <UI.Text isLoading h={Typography['fontsize.md']} w="80px" />
      <UI.Text isLoading h={Typography['fontsize.md']} w="55px" />
    </Stack>
  );

  return (
    <VStack space={Spacing['stack.xxxs']}>
      {Array.from({ length: quantity }).map((_, index) => (
        <UI.Shadow level={1} borderRadius={BoxBorder.heavy} key={index} p={Spacing['inset.sm']}>
          <VStack space={Spacing['stack.xxxs']}>
            <HStack alignItems="center" justifyContent="space-between">
              {renderDoubleTextLoading()}
              <HStack space={Spacing['inline.xxs']}>
                {!isMobile && (
                  <>
                    {renderDoubleTextLoading()}
                    {renderDoubleTextLoading()}
                  </>
                )}
                <IconButton
                  p={0}
                  variant="unstyled"
                  disabled
                  isDisabled
                  icon={<UI.Icon name={'ChevronDown'} size="xxs" color={Color['neutral.black']} />}
                />
              </HStack>
            </HStack>
            {!!isMobile && (
              <VStack space={Spacing['stack.nano']}>
                {renderDoubleTextLoading('row')}
                {renderDoubleTextLoading('row')}
              </VStack>
            )}
          </VStack>
        </UI.Shadow>
      ))}
    </VStack>
  );
};
